<template>
  <div>
    <v-dialog v-model="show" v-bind="$attrs" persistent eager>
      <v-card>
        <v-card-title class="font-weight-bold"
          ><v-img
            max-height="38px"
            max-width="200px"
            contain
            src="@/assets/payme_logo_color_oneline.png"
            position="left center"
          ></v-img
          >{{ header }}</v-card-title
        >
        <v-card-text class="pb-0">
          <v-row no-gutters justify="center">
            <v-col cols="8">
              <div class="font-weight-bold">
                {{ $t("message.scan_payme_qr_header1") }}
              </div>
              <div class="ma-0">
                <canvas ref="payCodeCanvas" width="280" height="280"></canvas>
              </div>
              <div class="font-italic font-weight-bold">
                {{ $t("message.auto_redirect_after_paid") }}
              </div>
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-col>
            <div>
              <div class="font-weight-bold">
                {{ $t("message.scan_payme_qr_header2") }}
              </div>
              <v-chip> 1 </v-chip>
              {{ $t("message.scan_payme_qr_step1") }}
              <br />
              <v-chip class="mt-1"> 2 </v-chip>
              {{ $t("message.scan_payme_qr_step2") }}
              <br />
              <v-chip class="mt-1"> 3 </v-chip>
              {{ $t("message.scan_payme_qr_step3") }}
            </div>
          </v-col>
          <v-divider></v-divider>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" small @click.stop="show = false">
            <v-icon>{{ mdiClose }}</v-icon
            >{{ $t("label.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbar-msg
      v-model="snackBarMsg.show"
      :text="snackBarMsg.text"
      :color="snackBarMsg.color"
    ></snackbar-msg>
  </div>
</template>

<script>
import { mdiClose, mdiLineScan } from "@mdi/js";
import { InquiryPayment } from "@/api/publicServices";
import * as qrcode from "qrcode-generator";
import { drawPayCode } from "@/api/paycode";

export default {
  props: {
    value: Boolean,
    url: {
      type: String,
      required: true,
    },
    logoUrl: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    paymentId: {
      type: String,
      required: true,
    },
  },
  components: {},
  computed: {
    show: {
      get() {
        console.log("show get: " + this.value);
        return this.value;
      },
      set(value) {
        console.log("payme dialog emit: " + value);
        this.reset();
        this.$emit("input", value);
      },
    },
  },
  data: () => ({
    canvas: null,

    polling: null,
    pollingNo: 0,

    snackBarMsg: {
      show: false,
      text: "",
      color: "red",
    },

    //svg icons
    mdiClose,
    mdiLineScan,
  }),
  methods: {
    async inquiryPayment() {
      try {
        let data = { PaymentID: this.paymentId, CallInquiryApi: false };
        this.pollingNo++;
        console.log("pollingNo: ", this.pollingNo);
        if (this.pollingNo > 11) {
          data.CallInquiryApi = true;
          console.log("data: ", data);
        }
        const response = await InquiryPayment(data);
        if (response.data.isSuccess) {
          this.updatePaymentStatus(true);
          console.log(response.data);
        } else if (response.data.Key == "FAIL") {
          this.updatePaymentStatus(false, response.data.Msg);
          console.log(response.data);
        }
      } catch (error) {
        // this.snackBarMsg.text = "Service Error";
        // this.snackBarMsg.show = true;
        console.log(error);
      }
    },
    updatePaymentStatus(status, failMsg) {
      this.reset();
      console.log("payme dialog emit: updatePaymentStatus");
      this.show = false;
      this.$emit("onPayme", { paymentStatus: status, failMsg: failMsg });
    },
    reset() {
      console.log("reset");
      this.getCanvasCtx().clearRect(
        0,
        0,
        this.getCanvasCtx().width,
        this.getCanvasCtx().height
      );
      this.pollingNo = 0;
      clearInterval(this.polling);
    },
    pollQuery() {
      if (this.url) {
        this.polling = setInterval(() => {
          console.log("pollData");
          this.inquiryPayment();
        }, 5000);
      }
    },
    createQrcode(text, typeNumber, errorCorrectionLevel, mode, mb) {
      qrcode.stringToBytes = qrcode.stringToBytesFuncs[mb];
      if (typeNumber == 0) {
        typeNumber = this.suggestTypeNumber(text);
      }

      var qr = qrcode(typeNumber || 4, errorCorrectionLevel || "M");
      qr.addData(text, mode);
      qr.make();

      return qr;
    },
    suggestTypeNumber(text) {
      var length = text.length;
      if (length <= 32) {
        return 3;
      } else if (length <= 46) {
        return 4;
      } else if (length <= 60) {
        return 5;
      } else if (length <= 74) {
        return 6;
      } else if (length <= 86) {
        return 7;
      } else if (length <= 108) {
        return 8;
      } else if (length <= 130) {
        return 9;
      } else if (length <= 151) {
        return 10;
      } else if (length <= 177) {
        return 11;
      } else if (length <= 203) {
        return 12;
      } else if (length <= 241) {
        return 13;
      } else if (length <= 258) {
        return 14;
      } else if (length <= 292) {
        return 15;
      } else {
        return 40;
      }
    },
    async updateQrcode() {
      console.log(this.url);
      this.pollQuery();

      var text = this.url;
      var t = 0;
      var e = "Q";
      var m = "Byte";
      var mb = "UTF-8";
      var qr = this.createQrcode(text, t, e, m, mb);

      //let logoUrl = require("@/assets/frogigo_logo_280x280.png");
      console.log(logo);
      let logo = await this.addImageProcess(this.logoUrl);
      console.log(logo);

      this.getCanvasCtx().setTransform(1, 0, 0, 1, 0, 0);
      this.getCanvasCtx().clearRect(
        0,
        0,
        this.getCanvasCtx().width,
        this.getCanvasCtx().height
      );
      console.log(this.canvas);
      drawPayCode(qr, this.canvas, 7, logo);
    },
    getCanvasCtx() {
      return this.canvas.getContext("2d");
    },
    addImageProcess(src) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    },
  },
  mounted() {
    //console.log(qrcode);
    this.canvas = this.$refs.payCodeCanvas;
  },
  beforeDestroy() {
    console.log("destroy");
    this.reset();
  },
};
</script>

<style lang="scss" scoped></style>
